import * as React from 'react';
import s from './Totals.scss';
import get from 'lodash.get';
import { Text, Heading } from 'wix-style-react';
import { translate } from 'react-i18next';
import { currencyFormat } from '../../../core';
var Totals = function (_a) {
    var t = _a.t, priceQuote = _a.priceQuote, locale = _a.locale;
    var subtotal = get(priceQuote.totals, 'subtotal.serializedValue', 0);
    var discountAmount = get(priceQuote.totals, 'discountAmount.serializedValue', 0);
    var total = get(priceQuote.totals, 'total.serializedValue', 0);
    var fees = get(priceQuote.totals, 'fees');
    var rate = get(priceQuote.discount, 'percentage.serializedValue');
    var taxes = get(priceQuote.taxes, 'taxes');
    var format = currencyFormat({
        locale: locale,
        currency: priceQuote.currencyCode,
    });
    return (React.createElement("div", { className: s.totals },
        React.createElement("div", { className: s.total },
            React.createElement(Text, { weight: "normal", dataHook: "subtotal-label" }, t('invoice-view:price-quote.view.totals.subtotal')),
            React.createElement("div", { className: s.totalValue },
                React.createElement(Text, { weight: "normal", dataHook: "subtotal-text" }, format(subtotal)))),
        !!fees &&
            fees.map(function (_a) {
                var name = _a.name, price = _a.price.serializedValue;
                return price !== 0 && (React.createElement("div", { key: "fee-".concat(name), className: s.total },
                    React.createElement(Text, { weight: "normal", dataHook: "fee-".concat(name, "-name") }, name),
                    React.createElement("div", { className: s.totalValue },
                        React.createElement(Text, { weight: "normal", dataHook: "fee-".concat(name, "-value") }, format(price)))));
            }),
        !!rate && (React.createElement("div", { className: s.total },
            React.createElement(Text, { weight: "normal", dataHook: "discount-label" }, t('invoice-view:price-quote.view.totals.discount', { rate: rate })),
            React.createElement("div", { className: s.totalValue },
                React.createElement(Text, { weight: "normal", dataHook: "discount-text" }, format(discountAmount))))),
        !!taxes &&
            taxes
                .filter(function (_a) {
                var taxed = _a.taxed.serializedValue;
                return !!taxed;
            })
                .map(function (_a) {
                var taxed = _a.taxed.serializedValue, taxRate = _a.rate.serializedValue, name = _a.name;
                return (taxed !== 0 && (React.createElement("div", { key: "".concat(name, "-").concat(taxRate), className: s.total },
                    React.createElement(Text, { weight: "normal", dataHook: "tax-".concat(name, "-").concat(taxRate, "-name") }, t('invoice-view:price-quote.view.totals.tax-rate', {
                        rate: taxRate,
                        name: name,
                    })),
                    React.createElement("div", { className: s.totalValue },
                        React.createElement(Text, { weight: "normal", dataHook: "tax-".concat(name, "-").concat(taxRate, "-taxed") }, format(taxed))))));
            }),
        React.createElement("div", { className: s.quoteTotal },
            React.createElement(Heading, { appearance: "H4", dataHook: "total-label" }, t('invoice-view:price-quote.view.totals.total')),
            React.createElement(Text, { className: s.totalValue, weight: "bold", size: "medium", dataHook: "total-text" }, format(total)))));
};
export default translate(['invoice-view', 'locale-data'])(Totals);
//# sourceMappingURL=Totals.js.map